import { ChangeDetectionStrategy, Component, HostBinding, Input } from "@angular/core";

@Component({
	selector: "ic-indicator",
	templateUrl: "./indicator.component.html",
	styleUrls: ["./indicator.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class IndicatorComponent {
	@Input() @HostBinding("class.active") active: boolean;
	@Input() @HostBinding("class.warning") warning: boolean;
	@Input() @HostBinding("class.danger") danger: boolean;

	@Input() text: string;
	@Input() icon = "fa fa-question-circle";
	@Input() disabled = false;
}
